// Progressive enhancement only. Shopify retains native validation and submission.
// No analytics emission, storage, network requests or collection of field values.
const initialized = new WeakSet();
const businessServices = new Set(['patronaje', 'prototipo', 'microcoleccion', 'uniformes', 'controlcalidad']);
const productionServices = new Set(['microcoleccion', 'uniformes']);
const validServices = new Set([...businessServices, 'encargo', 'producto', 'otro']);
const aliases = new Map([
  ['pattern-making', 'patronaje'], ['patronatge', 'patronaje'], ['schnittentwicklung', 'patronaje'],
  ['prototype', 'prototipo'], ['prototip', 'prototipo'], ['prototyp', 'prototipo'],
  ['microcolecciones', 'microcoleccion'], ['microcollection', 'microcoleccion'], ['small-batch', 'microcoleccion'],
  ['custom', 'encargo'], ['custom-order', 'encargo'], ['a-medida', 'encargo'],
  ['product', 'producto'], ['producte', 'producto'], ['other', 'otro']
]);

function canonicalService(value) {
  const normalized = String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
  return validServices.has(normalized) ? normalized : aliases.get(normalized) || null;
}

function initializeContactForms(scope = document) {
  for (const container of scope.querySelectorAll('[data-yvicor-contact-form]')) {
    if (initialized.has(container)) continue;
    const form = container.querySelector('form');
    const select = container.querySelector('[data-yvicor-contact-service]');
    const label = container.querySelector('[data-yvicor-contact-submit-label]');
    if (!form || !select || !label) continue;
    initialized.add(container);
    const parameters = new URL(window.location.href).searchParams;
    const origin = container.querySelector('[data-yvicor-contact-origin]');
    const description = container.querySelector('[data-yvicor-contact-description]');
    const descriptionQualifier = container.querySelector('[data-yvicor-contact-description-qualifier]');
    const descriptionHelp = container.querySelector('[data-yvicor-contact-description-help]');
    const productionHelp = container.querySelector('[data-yvicor-contact-production-help]');
    const units = container.querySelector('[data-yvicor-contact-units]');
    const intro = container.querySelector('[data-yvicor-contact-intro]');
    const generalSwitch = container.querySelector('[data-yvicor-contact-general]');
    const otherOption = [...select.options].find(option => option.value === 'otro');
    const otherLabel = otherOption?.textContent;
    const hasError = Boolean(container.querySelector('[data-yvicor-contact-error]'));
    const initialBrandContext = hasError
      ? origin?.value === 'marca'
      : ['marcas', 'brand', 'b2b'].includes((parameters.get('tipo') || '').toLowerCase());
    let brandContext = initialBrandContext;
    let projectRequested = false;
    const initialService = canonicalService(parameters.get('service'));
    // Submitted values take precedence on a server-side validation error.
    if (initialService && !hasError) {
      // Reset returns to this URL's initial context, just as native selected options do.
      for (const option of select.options) option.defaultSelected = option.value === initialService;
      select.value = initialService;
    }

    function validateDescription() {
      if (!description) return;
      description.setCustomValidity(projectRequested && !description.value.trim()
        ? description.dataset.requiredMessage : '');
    }

    function updateContext() {
      const service = canonicalService(select.value) || 'otro';
      const business = businessServices.has(service) || (brandContext && service === 'otro');
      const quote = business || service === 'encargo';
      projectRequested = quote;
      if (origin) {
        origin.value = brandContext && service === 'otro' ? 'marca' : '';
        origin.disabled = !origin.value;
      }
      if (otherOption && select.dataset.brandLabel) {
        otherOption.textContent = brandContext ? select.dataset.brandLabel : otherLabel;
      }
      if (generalSwitch) {
        generalSwitch.hidden = !brandContext;
        generalSwitch.style.display = brandContext ? 'inline-flex' : 'none';
      }
      if (description) {
        description.required = quote;
        description.setAttribute('aria-required', String(quote));
      }
      if (descriptionQualifier) descriptionQualifier.textContent = `(${quote ? descriptionQualifier.dataset.required : descriptionQualifier.dataset.optional})`;
      if (intro) intro.textContent = quote ? intro.dataset.project : intro.dataset.general;
      if (descriptionHelp) descriptionHelp.textContent = descriptionHelp.dataset[service] || (quote ? descriptionHelp.dataset.project : descriptionHelp.dataset.general);
      if (productionHelp) {
        productionHelp.hidden = !productionServices.has(service);
        // A hidden aria-describedby target can still be announced; attach it only where relevant.
        if (units) {
          if (productionHelp.hidden) units.removeAttribute('aria-describedby');
          else units.setAttribute('aria-describedby', productionHelp.id);
        }
      }
      validateDescription();
      const relevance = {
        business,
        quantity: quote,
        date: quote,
        reference: quote || service === 'producto',
      };
      for (const group of container.querySelectorAll('[data-yvicor-contact-context]')) {
        const relevant = relevance[group.dataset.yvicorContactContext] ?? true;
        group.hidden = !relevant;
        // Disabled controls keep their values but are excluded from native validation/submission.
        for (const control of group.querySelectorAll('input, select, textarea')) control.disabled = !relevant;
      }
      for (const row of container.querySelectorAll('[data-yvicor-contact-context-row]')) {
        row.hidden = [...row.querySelectorAll('[data-yvicor-contact-context]')].every(group => group.hidden);
      }
      label.textContent = quote ? label.dataset.quoteLabel : label.dataset.enquiryLabel;
      container.dataset.yvicorContactMode = quote ? 'quote' : 'enquiry';
    }
    select.addEventListener('change', () => { brandContext = false; updateContext(); });
    generalSwitch?.addEventListener('click', () => {
      brandContext = false;
      select.value = 'otro';
      updateContext();
      select.focus();
    });
    description?.addEventListener('input', validateDescription);
    form.addEventListener('reset', () => { queueMicrotask(() => { brandContext = initialBrandContext; updateContext(); }); });
    updateContext();
  }
}

initializeContactForms();
document.addEventListener('shopify:section:load', event => initializeContactForms(event.target));
